export default __webpack_public_path__ + "static/media/Averta-Regular.2a90ef87.woff";